import { render, staticRenderFns } from "./ResponsibilityTermGate.vue?vue&type=template&id=4689c624&scoped=true"
import script from "./ResponsibilityTermGate.vue?vue&type=script&lang=ts"
export * from "./ResponsibilityTermGate.vue?vue&type=script&lang=ts"
import style0 from "./ResponsibilityTermGate.vue?vue&type=style&index=0&id=4689c624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689c624",
  null
  
)

export default component.exports